<div class='content'>
<h1>человеческий тетрис</h1>
<p>Каждый день печатают миллиарды чеков. Средняя продолжительность использования чека — одна минута. Сможешь ли ты продержаться дольше?</p>

<a routerLink='/game' class='btn'>Давай поиграем!</a>
</div>
